import { graphql, SliceComponentProps } from "gatsby";
import React from "react";
import SliceProviders from "./SliceProviders";
import { CustomPromoSliceContext } from "./types";
import CustomPromo from "components/CustomPromo/CustomPromo";
import { CustomPromoComponentsSliceQuery } from "types/graphql-types";

const CustomPromoComponentsSlice: React.FC<
  SliceComponentProps<CustomPromoComponentsSliceQuery, CustomPromoSliceContext>
> = ({ data, sliceContext }) => (
  <SliceProviders languageCode={sliceContext.languageCode}>
    <CustomPromo
      languageCode={sliceContext.languageCode}
      content={data.subscribeFormContent?.promoBannerContent?.localized}
      promoConfigurationCode={
        data.subscribeFormContent?.promoConfiguration?.code
      }
      backgroundImage={data.subscribeFormContent?.backgroundImage}
      modalTitle={
        data.subscribeFormContent?.promoModalContent?.title?.localized
      }
      modalContent={
        data.subscribeFormContent?.promoModalContent?.content?.localized
      }
    />
  </SliceProviders>
);

export default CustomPromoComponentsSlice;

// eslint-disable-next-line import/no-unused-modules
export const query = graphql`
  query CustomPromoComponentsSlice {
    subscribeFormContent: subscribeToNewsletterContent {
      promoBannerContent {
        localized
      }
      backgroundImage {
        ...ImageWithAlt
      }
      promoConfiguration {
        code
      }
      promoModalContent {
        title {
          localized
        }
        content {
          localized
        }
      }
    }
  }
`;
